import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { KeyValue } from '../models/common';
import { Result } from '../models/common/resultResponse';
import { IBodyshopTypeApi } from './base/registration/bodyshopTypeApi';

const baseRoute: string = 'BodyshopType';

export class BodyshopTypeApi extends IBodyshopTypeApi {
  getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`);
  }
}

